/* eslint-disable no-useless-escape */
export const DATEFORMAT = "HH:mm DD MMM YYYY";
export const SHORTDATEFORMAT = "DD MMM YYYY";
export const IP_REGEX = "^((25[0-5]|(2[0-4]|1\\d|[1-9]|)\\d)(\\.(?!$)|$)){4}$";
export const DNS_REGEX =
  "^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)((,( |,)?((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))*)?$";
export const IPCIDR_REGEX = "^(?:[0-9]{1,3}\\.){3}[0-9]{1,3}(?:\\/([89]|[12][0-9]|3[0-2]))?(?!\\/)$";
export const SUBNET_REGEX =
  "^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$";
export const MAC_REGEX = "^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$";
export const MULTIDNS_REGEX =
  "^(?:(?:[01]?\\d{1,2}|2[0-4]\\d|25[0-5])\\.){3}(?:(?:[01]?\\d{1,2}|2[0-4]\\d|25[0-5]))(,\\s*(?:(?:[01]?\\d{1,2}|2[0-4]\\d|25[0-5])\\.){3}(?:(?:[01]?\\d{1,2}|2[0-4]\\d|25[0-5])))*$";
export const UUID_REGEX = "^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$";
export const SEARCHDOMAIN_REGEX =
  "^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$";
export const HOSTNAME_REGEX = "^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9]))$";
export const FQDN_REGEX =
  "^(?!.*?_.*?)(?!(?:[\\w]+?\.)?\-[\\w\\.\\-]*?)(?![\\w]+?\\-\\.(?:[\\w\\.\\-]+?))(?=[\\w])(?=[\\w\\.\\-]*?\\.+[\\w\\.\\-]*?)(?![\\w\\.\\-]{254})(?!(?:\\.?[\\w\\-\\.]*?[\\w\\-]{64,}\\.)+?)[\\w\\.\\-]+?(?<![\\w\\-\\.]*?\\.[\\d]+?)(?<=[\\w\\-]{2,})(?<![\\w\\-]{25})$";
export const FILENAME_REGEX = "^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-_]*[a-zA-Z0-9]))$";
export const EMAIL_REGEX = "^[a-zA-Z0-9_.+\\-]+@[a-zA-Z0-9\\-]+\\.[a-zA-Z0-9\\-\\.]+$";
export const USERNAME_REGEX = "^(?:(?:[a-zA-Z0-9@]+\\\\)?[a-zA-Z0-9_@]{1,255})$";
export const NAME_REGEX = "^[a-zA-Z ]+$";
export const URL_REGEX =
  "^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$";
export const HOSTNAME_FQDN_REGEX =
  "^(?!:\/\/)([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)*([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)$";

export const OSLIST = {
  windows: [
    "Windows 2000",
    "Windows XP",
    "Windows 2003",
    "Windows 2008 R2",
    "Windows 2008",
    "Windows 2012",
    "Windows 2012 R2",
    "Windows 2016",
    "Windows 2019",
    "Windows 2022",
    "Windows 7",
    "Windows 8",
    "Windows 8.1",
    "Windows 10",
    "Windows 11",
    "Windows XP",
    "Windows Vista",
    "unknown",
  ],
  linux: [
    "Red Hat Enterprise Linux 5",
    "Red Hat Enterprise Linux 6",
    "Red Hat Enterprise Linux 7",
    "Red Hat Enterprise Linux 8",
    "Red Hat Enterprise Linux 9",
    "SUSE Linux Enterprise Server 10",
    "SUSE Linux Enterprise Server 11",
    "SUSE Linux Enterprise Server 12",
    "SUSE Linux Enterprise Server 15",
    "Ubuntu Server 14",
    "Ubuntu Server 16",
    "Ubuntu Server 18",
    "Ubuntu Server 20",
    "Ubuntu Server 22",
    "Other Linux",
    "unknown",
  ],
  aix: ["AIX 6.1", "AIX 7.1", "AIX 7.2", "AIX 7.3", "unknown"],
  unknown: ["unknown"],
};
